import React from 'react';
import { motion } from 'framer-motion';
import Header from './Header';
import BottomNavigation from './BottomNavigation';

interface LayoutProps {
  children: React.ReactNode;
  showBottomNav?: boolean;
  className?: string;
}

const Layout: React.FC<LayoutProps> = ({ 
  children, 
  showBottomNav = true, 
  className = '' 
}) => {
  return (
    <div className={`min-h-screen bg-gray-50 flex flex-col ${className}`}>
      <Header />
      
      <motion.main
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
        className={`flex-1 ${showBottomNav ? 'pb-20' : ''} safe-bottom`}
      >
        {children}
      </motion.main>
      
      {showBottomNav && <BottomNavigation />}
    </div>
  );
};

export default Layout;